<template>
  <div class="materials-manager-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="类型">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable>
                <el-option label="入库" :value="1" />
                <el-option label="出库" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <el-date-picker
                v-model="searchForm.searchDate"
                size="small"
                tformat="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="SearchData"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="SearchData">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="tableLoading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                prop="type"
                label="类型"
                align="center"
                width="90"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini">入库</el-tag>
                  <el-tag v-if="scope.row.type===0" :disable-transitions="true" size="mini" type="danger">出库</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="物料名称"
                show-overflow-tooltip
                width="220"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="规格"
                align="center"
                width="90"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.spec }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                align="center"
                width="90"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.num + ' ' + scope.row.unit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="品牌"
                width="130"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.brand_name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作时间"
                width="170"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作人"
                align="center"
                width="110"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.user_name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                min-width="130"
                label="备注"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getStorageRecord } from '@/api/work'
import { getUserWorkRule } from '@/api/user'

export default {
  data() {
    return {
      searchForm: {
        type: '',
        search: '',
        searchDate: []
      },
      beginTime: '',
      endTime: '',
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableLoading: false,
      total: 0,
      isMenu: 0
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getMenu()
  },
  methods: {
    SearchData() {
      if (this.searchForm.searchDate !== '' && this.searchForm.searchDate !== null && this.searchForm.searchDate !== undefined) {
        if (this.searchForm.searchDate.length === 2) {
          this.beginTime = this.searchForm.searchDate[0]
          this.endTime = this.searchForm.searchDate[1]
        } else {
          this.beginTime = ''
          this.endTime = ''
        }
      } else {
        this.beginTime = ''
        this.endTime = ''
      }
      this.currentPage = 1
      this.getStorageRecord()
    },
    getMenu() {
      const data = {
        userid: this.user.dUserid,
        rule: this.user.rank,
        type: 0
      }
      getUserWorkRule(data).then(response => {
        for (const m of response.data) {
          if (m.name === '企划物料') {
            for (const menu of m.menulst) {
              if (menu.dNum === 'wlzl') {
                this.isMenu = 1
                break
              }
            }
            break
          }
        }
        this.getStorageRecord()
      })
    },
    getStorageRecord() {
      this.tableLoading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        mark: this.searchForm.type,
        content: this.searchForm.search,
        startTime: this.beginTime,
        endTime: this.endTime,
        groupid: this.user.dGroupid,
        isMenu: this.isMenu
      }
      getStorageRecord(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getStorageRecord()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getStorageRecord()
    }
  }
}
</script>

<style lang="scss" scoped>
.materials-manager-container {
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
      }
      .search-area{
        float: right;
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
